/**
* @Author: 858834013@qq.com
* @Name: index
* @Date: 2022-08-24
* @Desc:
*/
<template>
  <div class="itemBody">
    <titleInfo @getHide="getHide" :title="title">
    </titleInfo>
    <div class="itemBodyMain scrollBar">
      <div v-for="(item,index) in list" :key="index">
        <div class="itemBodyMainItem" :class="'type'+item.type">
          <div class="time">04-15 14:45:00</div>
          <message>
            <div class="name">中国科技大学</div>
          </message>
          <callPolice>
            <div class="info">1411教室疑似严重短路,</div>
          </callPolice>
          <div class="desc">责任人电话：67749789</div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import titleInfo from "@/components/titleInfo";
import message from "@/components/home/item6/message";
import callPolice from "@/components/home/item6/callPolice";

export default {
  name: "index",
  components: {titleInfo, message, callPolice},
  props: {
    title: {
      type: String,
      default() {
        return '';
      }
    }
  },
  data() {
    return {
      status: '',
      list: [{
        time: '04-15 14:45:00',
        name: '中国科技大学 ',
        info: '1411教室疑似严重短路',
        type: 1,
        desc: '责任人电话：67749789',
      }, {
        time: '04-15 14:45:00',
        name: '中国科技大学 ',
        info: '1411教室疑似严重短路',
        type: 2,
        desc: '责任人电话：67749789',
      }, {
        time: '04-15 14:45:00',
        name: '中国科技大学 ',
        info: '1411教室疑似严重短路',
        type: 3,
        desc: '责任人电话：67749789',
      }, {
        time: '04-15 14:45:00',
        name: '中国科技大学 ',
        info: '1411教室疑似严重短路',
        type: 4,
        desc: '责任人电话：67749789',
      }, {
        time: '04-15 14:45:00',
        name: '中国科技大学 ',
        info: '1411教室疑似严重短路',
        type: 0,
        desc: '责任人电话：67749789',
      }, {
        time: '04-15 14:45:00',
        name: '中国科技大学 ',
        info: '1411教室疑似严重短路',
        type: 0,
        desc: '责任人电话：67749789',
      }, {
        time: '04-15 14:45:00',
        name: '中国科技大学 ',
        info: '1411教室疑似严重短路',
        type: 0,
        desc: '责任人电话：67749789',
      }, {
        time: '04-15 14:45:00',
        name: '中国科技大学 ',
        info: '1411教室疑似严重短路',
        type: 0,
        desc: '责任人电话：67749789',
      }, {
        time: '04-15 14:45:00',
        name: '中国科技大学 ',
        info: '1411教室疑似严重短路',
        type: 0,
        desc: '责任人电话：67749789',
      }, {
        time: '04-15 14:45:00',
        name: '中国科技大学 ',
        info: '1411教室疑似严重短路',
        type: 0,
        desc: '责任人电话：67749789',
      }, {
        time: '04-15 14:45:00',
        name: '中国科技大学 ',
        info: '1411教室疑似严重短路',
        type: 0,
        desc: '责任人电话：67749789',
      }]
    }
  },
  watch: {},
  mounted() {
  },
  methods: {
    getHide() {
      this.$emit('getHide', 0)
    },
  }
}
</script>

<style lang="scss" scoped>
.itemBody {
  position: relative;
  width: 100%;
  height: 100%;

  .itemBodyMain {
    width: 100%;
    position: relative;
    height: calc(100% - 44px);
    overflow-y: scroll;

    .itemBodyMainItem {
      width: calc(100% - 30px);
      background: url("../../../assets/home/item6bg1.png") no-repeat;
      height: 36px;
      background-size: 100% 100%;
      margin-left: 10px;
      margin-right: 20px;
      margin-top: 10px;
      margin-bottom: 20px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      flex-wrap: nowrap;
      flex-direction: row;
      align-content: flex-start;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;

      .time {
        padding-left: 54px;
        font-size: 16px;
        font-family: PingFang;
        font-weight: 500;
        color: #CDF7FF;
        line-height: 14px;
        text-shadow: 0px 1px 1px rgba(3, 21, 110, 0.3);
      }

      .name {
        font-size: 16px;
        font-family: PingFang;
        font-weight: 500;
        color: #CDF7FF;
        margin-left: 20px;
      }

      .info {
        font-size: 16px;
        font-family: PingFang;
        font-weight: bold;
        color: #01A3FF;
        opacity: 0.8;
        margin-left: 20px;
      }

      .desc {
        color: rgba(202, 234, 255, 1);
        font-size: 16px;
        font-family: PingFang;
        font-weight: bold;
        margin-left: 5px;
      }
    }

    .itemBodyMainItem.type1 {
      background: url("../../../assets/home/item6bg2.png") no-repeat;
      background-size: 100% 100%;

      .info {
        color: #b4a02e;
      }
    }

    .itemBodyMainItem.type2 {
      background: url("../../../assets/home/item6bg3.png") no-repeat;
      background-size: 100% 100%;

      .info {
        color: #b8554c;
      }
    }
  }
}

</style>
